'use client';
import cn from 'classnames';
import styles from './ModalGallery.module.scss';
import { useRef, useState } from 'react';
import { Backdrop } from '../Backdrop';
import { createPortal } from 'react-dom';
import { getBackendImage } from '@/utils/getBackendImage';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

type ModalGalleryProps = {
  className?: string;
  active: boolean;
  onClose: () => void;
  items: string[];
};

export function ModalGallery({
  active,
  onClose,
  className,
  items,
}: ModalGalleryProps) {
  const wrapperClassName = cn(styles.wrapper, className);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null);

  if (!active) return null;

  return createPortal(
    <div className={wrapperClassName} ref={modalRef}>
      <Backdrop
        visible={active}
        onClick={onClose}
        className={styles.backdrop}
      />
      <div className={styles.desktop}>
        <img
          src={getBackendImage(items[activeImageIndex])}
          alt="item"
          className={styles.main}
        />
        <div className={styles.list}>
          {items.map((item, index) => (
            <div key={item} className={styles.item}>
              <img
                src={getBackendImage(item)}
                alt="item"
                className={cn(styles.itemImage, {
                  [styles.active]: activeImageIndex === index,
                })}
                onClick={() => setActiveImageIndex(index)}
              />
            </div>
          ))}
        </div>
        <img
          src="/svg/close-gray.svg"
          alt="close"
          className={styles.close}
          onClick={onClose}
        />
      </div>
      <div className={styles.tablet}>
        <div className={styles.header}>
          <div className={styles.empty} />
          <div className={styles.counter}>
            {activeImageIndex + 1} из {items.length}
          </div>
          <img
            src="/svg/close-white.svg"
            alt="close"
            className={styles.closeSlider}
            onClick={onClose}
          />
        </div>
        <div className={styles.sliderWrapper}>
          <Swiper
            className={styles.slider}
            effect="slide"
            slidesPerView={1}
            modules={[Pagination]}
            pagination={{
              bulletClass: styles.bullet,
              bulletActiveClass: styles.bulletActive,
              horizontalClass: styles.pagination,
            }}
            centeredSlides
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                <img
                  src={getBackendImage(item)}
                  alt="item"
                  className={styles.slide}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>,
    document.body,
  );
}
